export const platform = {
    labels: {
        name: "Nome",
        platform: "Plataforma",
        platforms: "Plataformas",
        description: "Descrição",
        add_platform: "Adicionar Plataforma",
        delete_platform: "Deletar Plataforma",
        groups: "Grupos",
        edit_platform: "Editar Plataforma",
        edit_group: "Editar Grupo",
        slug: "Slug",
    },
    placeholders: {
        name: "Informe o nome",
        description: "Informe a descrição",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_platform: "Adicionar Plataforma",
            del_platform: "Excluir Plataforma",
        },
        messages: {
        },
    },
    texts: {
        del_platform: "Você deseja mesmo excluir esta plataforma?<br/>Todos os cadastros desta plataforma serão excluídos.",
    },
};
